'use client';
import React, { useEffect, useState } from 'react';
import { Button, Div, Text } from '@pezeshk-book/ui-kit';
import checkIpApi from '@api/settings/check-ip';
import ReactGA from 'react-ga4';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [isIran, setIsIran] = useState(true);

  useEffect(() => {
    const storedCookieConsent = localStorage.getItem('cookie_consent');
    if (storedCookieConsent) {
      setShowBanner(false);
    }
  }, []);

  useEffect(() => {
    const storedCookieConsent = localStorage.getItem('cookie_consent');
    if (storedCookieConsent !== '"granted"') {
      checkIpApi({ cache: 'no-cache' }).then((response) => {
        setIsIran(response?.data?.is_iran);
        if (response?.data?.is_iran) {
          handleClick({ value: true });
        }
      })
        .catch(() => {
          setIsIran(false);
        });
    } else {
      handleClick({ value: true });
    }
  }, []);

  const handleClick = ({ value }: {value: boolean}) => {
    const newValue = value ? 'granted' : 'denied';
    setShowBanner(false);
    ReactGA.gtag('consent', 'update', {
      'ad_user_data': newValue,
      'ad_personalization': newValue,
      'ad_storage': newValue,
      'analytics_storage': newValue,
    });
    localStorage.setItem('cookie_consent', JSON.stringify(newValue));
  };

  if (!showBanner || isIran) {
    return null;
  }

  return (
    <Div className={`mx-auto w-full fixed top-0 left-0 right-0 px-2 md:px-4 py-4 justify-center items-center gap-4 z-[1000] bg-white rounded-b-lg shadow-2xl drop-shadow-2xl border-b-2 border-tertiary`}>
      <Div className={'items-center'}>
        <Text type={'bold'} typography={'xs'} className={'text-ellipsis whitespace-nowrap'}>برای تجربه کاربری بهتر کوکی را ذخیره میکنیم.</Text>
      </Div>
      <Div className={'gap-4 justify-center'}>
        <Button onClick={() => handleClick({ value: true })} className={'w-20'} rounded={'small'} size={'tiny'}>قبول</Button>
        <Button onClick={() => handleClick({ value: false })} color={'danger'} variant={'outlined'} rounded={'small'} size={'tiny'} className={'w-16'}>رد</Button>
      </Div>
    </Div>
  );
};

export default CookieBanner;
